import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModalModule } from 'ngx-bootstrap/modal';

import { NgUploaderModule } from '../../ngx-uploader/modules/ngx-uploader.module';
import { AppModalModule } from '../../modal/modal.module';
import { SearchModule } from '../../search/search.module';
import { LoaderModule } from '../../loader/loader.module';
import { IconModule } from '../../icon/icon.module';
import { ScrollModule } from '../../scroll/scroll.module';
import { ButtonModule } from '../../button/button.module';

import { UploadAssetsModalComponent } from './upload-assets-modal/upload-assets-modal.component';
import { AssetsEmptyStateComponent } from './assets-empty-state/assets-empty-state.component';
import { DragAssetsSpaceComponent } from './drag-assets-space/drag-assets-space.component';
import { UploadProgressComponent } from './upload-progress/upload-progress.component';
import { ErrorBannerComponent } from './error-banner/error-banner.component';
import { SuccessUploadModalComponent } from './success-upload-modal/success-upload-modal.component';
import { UploadAssetsComponent } from './upload-assets/upload-assets.component';


@NgModule({
  imports: [
    CommonModule,
    NgUploaderModule,
    AppModalModule,
    SearchModule,
    LoaderModule,
    IconModule,
    ScrollModule,
    ButtonModule,
    ModalModule,
  ],
  declarations: [
    UploadAssetsModalComponent,
    AssetsEmptyStateComponent,
    DragAssetsSpaceComponent,
    UploadProgressComponent,
    ErrorBannerComponent,
    SuccessUploadModalComponent,
    UploadAssetsComponent,
  ],
  exports: [
    UploadAssetsComponent,
  ]
})
export class UploadAssetsModule {}
